// @ts-strict-ignore
import { Typography } from '@mui/material'
import React from 'react'
import { classList } from 'services/styles'
import { makeStyles } from 'tss-react/mui'

export interface IInputGroupConnectorProps {
  style?: React.CSSProperties
  className?: string
  children?: any
}

const useStyles = makeStyles()(theme => ({
  container: {
    minHeight: 40.13, // align this to input heights so that rounding behaves identically
    height: '100%',
    background: theme.palette.grey[200],
    border: `1px solid ${theme.palette.grey[400]}`,
    transition: 'border 0.2s ease',
    color: theme.palette.grey[500],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: theme.spacing(0, 2),
    boxSizing: 'border-box',
    flexGrow: '0 !important',
    minWidth: 'auto !important',
    borderRadius: '6px',
    position: 'relative',
    overflow: 'hidden',
    zIndex: '1 !important',
    [theme.breakpoints.down('md')]: {
      marginTop: 0,
      padding: theme.spacing(0, 2),
    },
    '& .MuiButtonBase-root': {
      marginTop: -20,
      marginBottom: -20,
    },
  },
}))

const InputGroupConnector: React.FC<IInputGroupConnectorProps> = (props) => {
  const { classes } = useStyles()

  return (
    <Typography variant="body1" component="div" className={classList(classes.container, props.className)} style={props.style}>
      {props.children}
    </Typography>
  )
}

export default InputGroupConnector
